import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet';
import MuiPhoneNumber from "material-ui-phone-number"

import {
    FormControl,
    Typography
} from "@material-ui/core";
import { Button } from "../../../common/components/libs";
import { useStores } from "../../../hooks";
import { observer } from "mobx-react";
import Wrapper from "../components/wrapper";
import { NavLink, Redirect } from "react-router-dom";
import { SnackbarType } from "../../../stores/common";
import logo from "../../../common/assets/logo_big.png";
import { trackSignUp } from "../../utils/MetrikaService";
import {Trans, useTranslation} from "react-i18next";


const SignUp = () => {
    const {i18n, t} = useTranslation(["general", "auth"]);
    const [phone, setPhone] = useState("");

    const { authStore, generalStore, constantsStore } = useStores();

    useEffect(() => {
        authStore.getCurrentUser().then(()=>{
            const locale =  authStore.organizationBranch?
                authStore.organizationBranch.data.defaultLocaleId:
                "ru";
            generalStore.setLocale({
                id: locale
            });
            const currencyNameId = authStore.organizationBranch?
                authStore.organizationBranch.data.defaultCurrencyId:
                "RUB";
            const currencyName = constantsStore.getLocalisedCurrencyName(currencyNameId);
            const currencyShortName = constantsStore.getLocalisedCurrencyShortName(currencyNameId);
            const currency = {id: currencyNameId, decimalPlaces: 2, currencyName: {[locale]: currencyName}, currencyShortName: {[locale]: currencyShortName}};
            generalStore.setCurrency(currency);
            i18n.changeLanguage(locale);
        })
    }, [authStore]);

    if (authStore.isAuthorized) {
        return <Redirect to="/"/>
    }

    const onSubmit = async () => {
        const phoneNumber = phone.replace(/\s/g, "").slice(1);
        const isOk = await authStore.signUp(phoneNumber);
        if (!isOk) {
            generalStore.showSnackbar({
                type: SnackbarType.error,
                title: t("auth:errorWithCreationAccount"),
                description: t("auth:sureNoAccountForNumber")
            })
        }else{
            trackSignUp();
        }
    };

    return (
        <div>
            <Wrapper>
                <Helmet title={t("auth:registration")}/>

                <Typography component="h1" variant="h4" align="center" gutterBottom>
                    {t("auth:creationAccount")}
                </Typography>
                <Typography component="h4" variant="body2" align="center" gutterBottom>
                    {t("auth:inputNumber")}
                </Typography>
                <form>
                    <FormControl margin="normal" required fullWidth>
                        <MuiPhoneNumber
                            defaultCountry={'ru'}
                            id="phone"
                            onChange={setPhone}
                            value={phone}
                        />
                        <br/>
                    </FormControl>
                    <Button
                        onClick={onSubmit}
                        fullWidth
                        variant="contained"
                        color="primary"
                        mb={2}
                    >
                        {t("auth:signUp")}
                    </Button>
                    <Button
                        component={NavLink}
                        to="/auth/sign-in"
                        fullWidth
                        color="primary"
                    >
                        {t("auth:haveAccount")}
                    </Button>
                </form>
            </Wrapper>
            <div style={{ textAlign: "center", marginTop: 20, marginLeft: -10 }}>
                <img src={logo} alt="" style={{ height: 20 }}/>
            </div>
        </div>
    );
};


export default observer(SignUp)
